import dompurify from 'dompurify'
import {
  Activity,
  ActivityGroup,
  ActivityType,
  ACTIVITY_WHITE_LIST,
} from 'lib/_types'

export const isValidActivity = (activity: Activity) =>
  activity.type && ACTIVITY_WHITE_LIST.includes(activity.type)

export const sanitizeContent = (text: string) => {
  return dompurify.sanitize(text, { ALLOWED_TAGS: ['b'], ALLOWED_ATTR: [] })
}

export const isGroupActivityAlreadyAction = (
  activities: Activity[],
  actionedActivities: ActivityType[],
  groupId: number,
  timestamp: number
) => {
  return !!activities
    .filter(({ type }) => actionedActivities.includes(type))
    .find(
      ({ group, created_at }: Activity & { group?: ActivityGroup }) =>
        group?.id === groupId && created_at > timestamp
    )
}
